var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPandas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.6735 4.72915H29.0513V22.8836H37.6735V4.72915Z",
    fill: "#130754"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6735 42.0216H29.0513V60.176H37.6735V42.0216Z",
    fill: "#130754"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6735 28.1826H29.0513V36.748H37.6735V28.1826Z",
    fill: "#FFCA00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8222 19.6534H15.2V80H23.8222V19.6534Z",
    fill: "#130754"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2386 57.0003H42.6164V75.1547H51.2386V57.0003Z",
    fill: "#130754"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2386 19.6752H42.6164V37.8296H51.2386V19.6752Z",
    fill: "#130754"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2386 43.1322H42.6164V51.6977H51.2386V43.1322Z",
    fill: "#E70488"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8 0H56.1778V60.3466H64.8V0Z",
    fill: "#130754"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPandas);
export default __webpack_public_path__ + "static/media/pandas.6d8fb9eec2e91ff48ca31c8ffcb17d70.svg";
export { ForwardRef as ReactComponent };